export const CallType = {
  Inbound: 'Inbound',
  Outbound: 'Outbound'
}
